import Button, { ButtonProps } from "@material-ui/core/Button";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { BaseCSSProperties } from "@material-ui/core/styles/withStyles";
import { forwardRef } from "react";
import { spaceBetween } from "../../../common/util/Array/spaceBetween";

type Props = { style?: BaseCSSProperties } & Omit<
    ButtonProps,
    "style" | "buttonRef"
>;

export const DarkButton = forwardRef<HTMLButtonElement, Props>(
    ({ style, className, disabled, ...rest }, ref) => {
        const c = useStyles({ style, disabled });
        return (
            <Button
                {...rest}
                className={spaceBetween(className, c.button)}
                ref={ref}
                style={{ color: "white" }} // disabled時の上書き対策のため、文字色をstyleで指定
                disabled={disabled}
            />
        );
    }
);
const useStyles = makeStyles<
    Theme,
    { style?: BaseCSSProperties; disabled?: boolean }
>(({ palette }) => ({
    button: ({ style, disabled }) => ({
        backgroundColor: disabled ? palette.grey[500] : palette.grey[800],
        "&:hover": {
            backgroundColor: palette.grey[700],
        },
        fontSize: "medium",
        ...style,
    }),
}));
